<template>
  <v-select
    type="text"
    dense
    outlined
    v-model="modelData"
    :label="placeholder"
    :name="name"
    :items="listaDeOptions"
    :item-text="optionLabel"
    :item-value="optionValue"
    :disabled="somenteLeitura"
    :multiple="selecaoMultipla"
    @change="$emit('change', $event)"
    :class="error ? 'show-errors' : 'hide-error'"
    placeholder="Selecione"
    v-bind="$attrs"
    :no-data-text="msgSemDados"
    :error-messages="error"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index < 1">{{ item[optionLabel] }}</span>
      <span v-if="index === 1" class="text-grey text-caption ">
        (+{{ modelData.length - 1 }} selecionados)
      </span>
      <span v-if="index > 1" class="d-none"></span>
    </template>
    <template v-slot:prepend-item>
      <v-list-item @click="toggleSelectAll" v-if="selecaoMultipla">
        <v-list-item-content>
          <v-checkbox 
            class="text-grey text-caption font-size-8" 
            :input-value="selectAll" 
            label="Selecionar Tudo">
          </v-checkbox>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SGPFormSelectComponent',

  props: {
    error: String,
    value: {
      required: true
    },
    name: String,
    placeholder: {
      type: String,
      default: ''
    },
    listaDeOptions: {
      type: Array,
      required: true,
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    selecaoMultipla: {
      type: Boolean,
      default: false
    },
    formatoBotao: {
      type: Boolean,
      default: false
    },
    formatoBotaoExcluir: {
      type: Boolean,
      default: false
    },
    msgSemDados: {
      type: String,
      default: 'Dados não disponíveis'
    }
  },

  computed: {
    modelData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    selectAll: {
      get() {
        return (this.modelData && this.listaDeOptions) &&
          this.modelData.length === this.listaDeOptions.length;
      }
  }
  },

  methods: {
    toggleSelectAll() {
      this.modelData = this.selectAll ? [] : 
        this.listaDeOptions.map(option => option[this.optionValue]);
      this.$emit('change', this.modelData);
    }
  }
}
</script>

<style lang="scss">
.hide-error.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}

.font-size-8 {
  font-size: 8px; 
}
</style>
